exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-list .add-version-btn[data-v-6902afa8] {\n  float: right;\n  margin-top: 9px;\n  margin-bottom: 16px;\n}\n[data-v-6902afa8] .el-tabs__item {\n  padding: 0 50px !important;\n}\n[data-v-6902afa8] .fade-enter-active,[data-v-6902afa8] .fade-leave-active {\n  -webkit-transition: opacity 0.5s;\n  transition: opacity 0.5s;\n}\n[data-v-6902afa8] .fade-enter,[data-v-6902afa8].fade-leave-to {\n  opacity: 0;\n}", ""]);

// exports
